import { BaseRouteService } from 'core/services';

class ProductActivityRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'product-activity-view/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}
}

export default ProductActivityRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/ProductActivityRouteService.js